
define('text!Magento_Checkout/template/summary/totals.html',[],function () { return '<!-- ko if: isDisplayed() --><div class="sidebar-content"><strong class="summary title" data-bind="i18n: \'Basket Total\'"></strong><!-- ko foreach: elems() --> <!-- ko template: getTemplate() --><!-- /ko --><!-- /ko --></div><!-- /ko -->';});

